import React, { useEffect } from 'react'
import 'loading-indicator-pattern/dist/main.css'



const Loader: React.FC = () => {
  useEffect(() => {
    document.body.classList.add('app-loader-active');
    return () => {
      document.body.classList.remove('app-loader-active');
    };
  }, []);

  return (
    <output
      className="fixed inset-0 flex items-center justify-center z-100 bg-black/25 px-4 sm:px-0"
      aria-live="polite"
      data-testid="loader"
    >
      <div
        className="ds-loadingindicator bg-white mobile:p-4 py-10! rounded-lg shadow flex flex-col items-center justify-center text-center w-full max-w-70 box-border"
        data-ds-theme="vessel"
        data-ds-variant="basic"
        data-ds-version="1"
      >
        <div
          className="loading-indicator__dots flex  items-center gap-2"
          aria-hidden
        >
          <div className="loading-indicator__dots--butllet" />
          <div className="loading-indicator__dots--butllet" />
          <div className="loading-indicator__dots--butllet" />
        </div>

        <div className="loading-indicator__content mt-1">
          <div
            className="loading-indicator__heading -book"
            tabIndex={-1}
            id="loading-id-xl"
          >
            Loading
          </div>
        </div>
      </div>
    </output>
  )
}

export default Loader
